import { clearLegalCache } from '../components/modals/legal-loader';
import { onLanguageChanged } from './index';
import { updateStaticDom } from './static-dom';
import { remountAuthModal } from '../components/modals/auth';
import { remountViewModal } from '../components/modals/view';
import { remountEditHeadstoneModal } from '../components/modals/edit-headstone';
import { remountAccountMenuModal } from '../components/modals/account-menu';
import { remountPaywallModal } from '../components/modals/paywall';
import { refreshAds } from '../features/ads';
import { updateAccountCard, refreshAuthButtonTitle } from '../features/auth-flow';
import { refreshPostsFeedOnLocale } from '../features/posts-feed';
import { initMemorialTributes, refreshViewModalOnLocale } from '../features/memorial-tributes';
import { updateZoomButton } from '../map/camera';
import { updateMyMemorialButtonLabels } from '../features/go-to-my-memorial';
import { remountConsentBanner } from '../components/consent-banner/consent-banner';
import { refreshGrazieOnLocale } from '../features/payment-thanks';

declare const lucide: { createIcons: () => void } | undefined;

function remountEagerModals(): void {
  remountAuthModal();
  remountViewModal();
  remountEditHeadstoneModal();
  remountAccountMenuModal();
  remountPaywallModal();
}

export function initI18nRemount(): void {
  onLanguageChanged(() => {
    clearLegalCache();
    updateStaticDom();
    remountEagerModals();
    initMemorialTributes();
    refreshAuthButtonTitle();
    updateZoomButton();
    refreshPostsFeedOnLocale();
    refreshViewModalOnLocale();
    updateMyMemorialButtonLabels();
    remountConsentBanner();
    refreshGrazieOnLocale();
    refreshAds();
    if (typeof lucide !== 'undefined') lucide.createIcons();
  });
}

export function remountI18nUI(): void {
  updateStaticDom();
  remountEagerModals();
}
